'use client'

import useIsMobile from '@/hooks/useIsMobile'
import { TestimonialProps } from '@/widgets/landing-page-widgets/TestimonialSection/schema'
import { Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'
import React from 'react'
import styles from './testimonials.module.css'

const Testimonial = ({
  item,
  index,
  updatePlayingInd,
  isPlaying,
}: {
  item: TestimonialProps
  index: number
  updatePlayingInd: (p: React.SetStateAction<number>) => void
  isPlaying: boolean
}) => {
  const { isMobile } = useIsMobile()

  const handleMouseEnter = () => {
    if (!isMobile) {
      updatePlayingInd(index)
    }
  }
  const handleMouseLeave = () => {
    if (!isMobile) {
      updatePlayingInd(-1)
    }
  }
  const handleToggleOpen = () => {
    if (isMobile) {
      updatePlayingInd(index)
    }
  }

  return (
    <div
      className="h-[498px] w-full rounded-2xl relative overflow-hidden" style={{boxShadow: '0px 1px 8px 0px #00000014'}} 
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleToggleOpen}
    >
      <Image
        src={item?.thumbnail}
        fill
        alt='Student Image'
        loading='lazy'
        className='object-cover object-center'
        sizes='(max-width: 768px) 80vw, 25vw'
        priority={false}
      />

  {!isPlaying && <div className="w-full h-full absolute top-0 left-0" style={{background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.91) 80.92%)'}} />}

      {isPlaying ? (
        <div className="w-full absolute h-full">
          <iframe
            src={`${item?.testimonialURL}&autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1&enablejsapi=1&widgetid=1`}
            className="w-full h-full aspect-[9/16] rounded-xl"
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
            title='Testimonial Video'
          />
        </div>
      ) : (
        <div className="p-4 md:p-6 absolute bottom-0">
          <Typography variant='heading3' weight='semi-bold' color='#fff'>
            {item?.title}
          </Typography>
          <Typography variant='regular' className="mt-2" color='#fff'>
            {item?.subTitle}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default Testimonial
